import { sendGaEvent } from "../../../../config/userTracking";
import { useRouter } from "next/router";
import { LinkButton } from "../../components/LinkButton";

export const onLandingButterLinkClick = (e, pathname, section) => {
  let target = e?.target;

  sendGaEvent({
    action: "Button Click",
    category: "SEO",
    ...(target && {
      label: `${target?.innerText.slice(0, 10)} - ${
        section ? `${section.slice(0, 10)} - ` : " "
      }${pathname}`,
    }),
  });

  return false;
};

export const LandingButterLink = ({
  url,
  className,
  external = false,
  section,
  children,
  demystIcon,
  variant,
  size,
  onClick,
  noStyle = false,
  mainCTA,
}) => {
  const router = useRouter();
  const pathname = router.asPath;

  const sanitizeButterUrl = url => {
    const isValidHttpUrl = string => {
      let jsUrl;

      try {
        jsUrl = new URL(string);
      } catch (e) {
        return false;
      }

      return jsUrl.protocol === "http:" || jsUrl.protocol === "https:";
    };

    if (isValidHttpUrl(url))
      return {
        target: "_blank",
        rel: "noreferrer noopener",
        to: new URL(url),
      };

    return {
      to: url.endsWith("/") ? url.slice(0, -1) : url,
      ...(external === true && { isExternal: true }),
    };
  };

  return (
    <LinkButton
      {...sanitizeButterUrl(url)}
      className={className}
      onClick={event => {
        onLandingButterLinkClick(event, pathname, section);
        onClick instanceof Function && onClick();
      }}
      demystIcon={demystIcon}
      size={size}
      variant={variant}
      noStyle={noStyle}
      mainCTA={mainCTA}
    >
      {children}
    </LinkButton>
  );
};
